module.exports = __webpack_public_path__ + "media/images/application/template/cc-home-bkg-1600px-1fb1bc1c280afbaabfa41a78419b5b16.jpg";